<template>
  <div :class="$style.racesAll">
    <div :class="$style.title" />
    <div :class="$style.actualRaces">
      <div :class="$style.actualRace">
        <div :class="$style.subTitle" />
        <div :class="$style.raceCard" />
      </div>
      <div :class="$style.actualRace">
        <div :class="$style.subTitle" />
        <div :class="$style.raceCard" />
      </div>
    </div>
    <div>
      <div :class="$style.subTitle" />
      <ul :class="$style.racesFinished">
        <li v-for="index in count" :key="index" :class="$style.raceCard" />
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

defineOptions({
  name: 'UiSkeletonRacesAll',
  inheritAttrs: false
})

const props = withDefaults(
  defineProps<{
    count?: number
  }>(),
  {
    count: 3
  }
)

const count = computed(() => (props.count && props.count > 0 ? props.count : 3))
</script>

<style module lang="scss">
@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

.skeletonItem {
  background: var-default(--skeleton-item-bg);
  border-radius: 0.8em;
  overflow: hidden;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    transform: translateX(-100%);
    background: linear-gradient(
      to right,
      transparent,
      hsla(0deg, 0%, 100%, 0.3),
      transparent
    );
    animation: shimmer 1.5s infinite;
  }
}

.racesAll {
  cursor: wait;
}

.title {
  @extend .skeletonItem;
  width: 20em;
  height: 2.4em;
  margin-bottom: 2.4em;
  border-radius: 0.6em;
}

.actualRaces {
  display: flex;
  gap: 2.4em;
  margin-bottom: 2.4em;

  @include down(md) {
    flex-direction: column;
  }
}

.actualRace {
  &:first-child {
    width: calc(70% - 1.2em);
  }

  &:last-child {
    width: calc(30% - 1.2em);
  }

  @include down(md) {
    &:first-child {
      width: auto;
    }

    &:last-child {
      width: auto;
    }
  }
}

.subTitle {
  @extend .skeletonItem;
  width: 15em;
  height: 1.8em;
  margin-bottom: 2em;
  border-radius: 0.6em;
}

.raceCard {
  background-color: color-get(--root-rgb-bg-card);
  border-radius: 2em;
  padding: 2em;
  min-height: 20em;
  position: relative;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    transform: translateX(-100%);
    background: linear-gradient(
      to right,
      transparent,
      hsla(0deg, 0%, 100%, 0.3),
      transparent
    );
    animation: shimmer 1.5s infinite;
  }
}

.racesFinished {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 2.4em;
  margin: 0;
  padding: 0;
  list-style: none;

  @include down(md) {
    grid-template-columns: 1fr;
  }
}
</style>
